<template>
    <div class="contentblock">
        <section class="contentblock__content">
            <div class="shop__fieldgroup shop__fieldgroup--no-separator">
                <div class="shop__fieldgroup-title">{{Strings['Shop.PricingDisabled.Title']}}</div>
                <p class="shop__partner-text" style="font-size: 1.8rem">{{Strings['Shop.PricingDisabled.Text']}}</p>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        computed: {
            ...mapState([
                'Strings'
            ])
        },
        methods: {
            startOver() {
                this.$router.push('/').catch(() => { });
            }
        }
    };
</script>